export default __webpack_public_path__ + "static/media/login.6b7fa681.svg";